export default __webpack_public_path__ + "static/hetzner_community_1-133e2e5f45f5344c95034c2294d859ac.jpg";